export const trackingPixelPath = "/Com/SPI.gif";
